// noinspection JSNonASCIINames,NonAsciiCharacters

export const currencyTranslations = {
    currency: {
        commonUsedGroup: "Sagedamini kasutatavad",
        otherGroup: "Teised",
        "EUR": "Euro",
        "USD": "USA dollar",
        "GBP": "Suurbritannia nael",
        "PLN": "Poola zlott",
        "SEK": "Rootsi kroon",
        "NOK": "Norra kroon",
        "PHP": "Filipiini peeso",
        "CZK": "Tšehhi kroon",
        "UAH": "Ukraina grivna",
        "ISK": "Islandi kroon",
        "CAD": "Kanada dollar",
        "CHF": "Šveitsi frank",
        "AUD": "Austraalia dollar",
        "RUB": "Venemaa rubla",
        "VND": "Vietnami dong",
        "INR": "India ruupia",
        "CNY": "Hiina jüaan",
        "HUF": "Ungari forint",
        "RON": "Rumeenia leu",
    }
}